/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_File_EncodingInputs */

const en_dialogue_list_export_file_encoding = /** @type {(inputs: Dialogue_List_Export_File_EncodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Encoding`)
};

const fr_dialogue_list_export_file_encoding = /** @type {(inputs: Dialogue_List_Export_File_EncodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encodage du fichier`)
};

const de_dialogue_list_export_file_encoding = /** @type {(inputs: Dialogue_List_Export_File_EncodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateikodierung`)
};

const it_dialogue_list_export_file_encoding = /** @type {(inputs: Dialogue_List_Export_File_EncodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica dei file`)
};

const ru_dialogue_list_export_file_encoding = /** @type {(inputs: Dialogue_List_Export_File_EncodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кодировка файла`)
};

const es_dialogue_list_export_file_encoding = /** @type {(inputs: Dialogue_List_Export_File_EncodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificación de archivos`)
};

const zh_cn2_dialogue_list_export_file_encoding = /** @type {(inputs: Dialogue_List_Export_File_EncodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件编码`)
};

const ja_dialogue_list_export_file_encoding = /** @type {(inputs: Dialogue_List_Export_File_EncodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルのエンコーディング`)
};

const hi_dialogue_list_export_file_encoding = /** @type {(inputs: Dialogue_List_Export_File_EncodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल एन्कोडिंग`)
};

const pt_pt2_dialogue_list_export_file_encoding = /** @type {(inputs: Dialogue_List_Export_File_EncodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificação de arquivo`)
};

/**
* | output |
* | --- |
* | "File Encoding" |
*
* @param {Dialogue_List_Export_File_EncodingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_file_encoding = /** @type {((inputs?: Dialogue_List_Export_File_EncodingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_File_EncodingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_file_encoding(inputs)
	if (locale === "de") return de_dialogue_list_export_file_encoding(inputs)
	if (locale === "it") return it_dialogue_list_export_file_encoding(inputs)
	if (locale === "ru") return ru_dialogue_list_export_file_encoding(inputs)
	if (locale === "es") return es_dialogue_list_export_file_encoding(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_file_encoding(inputs)
	if (locale === "ja") return ja_dialogue_list_export_file_encoding(inputs)
	if (locale === "hi") return hi_dialogue_list_export_file_encoding(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_file_encoding(inputs)
	return en_dialogue_list_export_file_encoding(inputs)
});